import api from './api';
import { LoginCredentials, SignupCredentials, ApiResponse, User, PartnerRegistrationData, Partner } from '../types';

interface UserRegistrationData {
  role: 'user';
  profilePicUrl?: string;
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  phoneNumber: string;
  about?: string;
}

export interface VerifyEmailResponse {
  user?: User;
  token?: string;
}

export const authService = {
  async login(credentials: LoginCredentials): Promise<ApiResponse<{ user: User; token: string }>> {
    const response = await api.post('/user/login', credentials);
    return response.data;
  },

  async signup(credentials: SignupCredentials): Promise<ApiResponse<{ user: User; token: string }>> {
    const response = await api.post('/user/register', credentials);
    return response.data;
  },

  async registerUser(userData: UserRegistrationData): Promise<ApiResponse<User>> {
    const response = await api.post('/user/register', userData);
    return response.data;
  },

  async registerPartner(partnerData: PartnerRegistrationData): Promise<ApiResponse<Partner>> {
    const response = await api.post('/user/register', partnerData);
    return response.data;
  },

  async getCurrentUser(): Promise<ApiResponse<User>> {
    const response = await api.get('/user/profile');
    return response.data;
  },

  async verifyEmail(data: { email: string; otp: string }): Promise<ApiResponse<VerifyEmailResponse | null>> {
    const response = await api.post('/user/verify-email', data);
    return response.data;
  },

  async resendVerification(data: { email: string }): Promise<ApiResponse<null>> {
    const response = await api.post('/user/resend-verification', data);
    return response.data;
  },

  async updateProfile(userData: Partial<User>): Promise<ApiResponse<User>> {
    const response = await api.put('/user/profile', userData);
    return response.data;
  },

  async refreshToken(): Promise<ApiResponse<{ token: string }>> {
    const response = await api.post('/user/refresh-token');
    return response.data;
  },
};
